import {functionRouteEntities} from 'views/DiscoveryMapExplorer/discoveryMapExplorerRouteEntities'
import {SearchTypes} from 'views/Search/SearchProvider'
import {staticPaths} from 'routes/staticPaths'

// 10 app trong "Kristo Apps" cần ghi nhận lượt ghé gần nhất, hiển thị lại làm shortcut
// (RecentAppsSiderShortcuts ở sidebar trái desktop, RecentAppsQuickAccessRow đầu trang /apps mobile).
// group+key trỏ đúng entity đã có sẵn trong functionRouteEntities (nguồn dữ liệu /apps +
// AppGroupBlock) - tái dùng icon/label/href có sẵn, KHÔNG tạo nguồn dữ liệu song song.
// "Kristo Prayers" -> key 'prayers' (group 'suggested') = Hiệp Nguyện/Ý cầu nguyện (đã chốt với
// user - phân biệt với key 'prayer' group 'liturgy' = Kinh Nguyện/Prayer Books, không dùng ở đây).
export const RECENT_APP_ENTITY_REFS = {
    courses: {group: 'partner', key: 'courses'},               // Kristo Edu
    family_books: {group: 'partner', key: 'family_books'},     // Kristo Family
    missals: {group: 'liturgy', key: SearchTypes.MISSALS},      // Kristo Missals
    music: {group: 'liturgy', key: 'music'},                    // Kristo Hymns
    documents: {group: 'education', key: 'documents'},          // Kristo Library
    games: {group: 'education', key: 'games'},                  // Kristo Games
    asks: {group: 'education', key: 'asks'},                    // Kristo Discussions
    churches: {group: 'partner', key: 'churches'},              // Kristo Mass Times
    directories: {group: 'partner', key: 'directories'},        // Kristo Directory
    prayers: {group: 'suggested', key: 'prayers'},              // Kristo Prayers

    // Không nằm trong 10 app cần ghi nhận lượt ghé - chỉ dùng làm 1 trong 3 fallback mặc định
    // (DEFAULT_RECENT_APP_IDS) khi user chưa có lịch sử nào.
    liturgy_calendar: {group: 'liturgy', key: 'liturgy_calendar'},
}

// pathname (bỏ qua query string) -> app id ở trên. Dùng để nhận diện lúc điều hướng
// (RecentAppsTracker) - cùng cách PATHNAME_TO_PAGE_KEY của components/PageViewTracker.js đang khớp
// theo pathname, không tạo cơ chế route-matching riêng.
export const PATHNAME_TO_RECENT_APP_ID = {
    [staticPaths.edu.pathname]: 'courses',
    [staticPaths.familyBooks.pathname]: 'family_books',
    [staticPaths.missals.pathname]: 'missals',
    [staticPaths.hymns.pathname]: 'music',
    [staticPaths.documentLibrary.pathname]: 'documents',
    [staticPaths.games.pathname]: 'games',
    [staticPaths.discussions.pathname]: 'asks',
    [staticPaths.massTimes.pathname]: 'churches',
    [staticPaths.discovery.pathname]: 'directories',
    [staticPaths.devotions.pathname]: 'prayers',
}

// Fallback khi user chưa từng ghé app nào trong 10 mục trên - đã chốt với user: Mass Times, Hymns,
// Lịch Phụng Vụ (theo đúng thứ tự ưu tiên bù chỗ trống, xem useRecentApps.js).
export const DEFAULT_RECENT_APP_IDS = ['churches', 'music', 'liturgy_calendar']

// Màu định danh icon - ĐÚNG bộ màu mỗi trang đang khai báo (brand color trang đó), không phải 1
// màu chung cho tất cả (phản hồi thực tế: icon Kristo Library ở sidebar không khớp màu nâu/cam
// header thật của /documents). KHÔNG dùng var(--color-hymns/family/education/prayer) dù 4 app này
// đã có biến CSS chính thức (custom.scss) - các biến đó CHỈ định nghĩa trong scope riêng
// (.hymns-theme/.family-theme/.education-theme/.prayer-theme) của chính trang đó, sidebar này nằm
// NGOÀI mọi scope đó nên var() không resolve được (đúng lỗi đã có sẵn ghi chú ở PrayerIntentionIcon
// trong discoveryMapExplorerRouteEntities.js) - hardcode hex lấy đúng giá trị base của biến/đúng
// màu icon-tile header thật từng trang (khảo sát trực tiếp từng page, KHÔNG tự chế màu mới):
// - courses/family_books/music/prayers: giá trị base của --color-education/family/hymns/prayer.
// - missals/documents/games/asks/churches/directories: màu icon-tile ở header thật của trang đó
//   (MissalHeader/DocumentsHeader/GamesHeader/DiscussionsHeader/MassTimesHeader/DiscoveryHeader).
// Dùng `icon` (đơn sắc, currentColor) thay vì `tileIcon` (tự có màu riêng, không đổi được qua
// CSS color) cho các component hiển thị shortcut này - xem RecentAppsSiderShortcuts.js/
// RecentAppsQuickAccessRow.js.
export const RECENT_APP_ICON_COLORS = {
    courses: '#1c4a75',       // --color-education
    family_books: '#b45309',  // --color-family
    missals: '#2f5233',       // Missals.js MissalHeader - icon tile
    music: '#2563eb',         // --color-hymns
    documents: '#92400e',     // DocumentsPage.js DocumentsHeader - icon tile (amber-800)
    games: '#7e22ce',         // GamesPage.js GamesHeader - icon tile (purple-700)
    asks: '#f59e0b',          // DiscussionsPage.js DiscussionsHeader - icon tile (amber-500)
    churches: '#0f766e',      // MassTimesPage.js MassTimesHeader - icon fill (teal-700)
    directories: '#c2410c',   // DiscoveryPage.js DiscoveryHeader - icon tile (orange-700)
    prayers: '#7b5ea7',       // --color-prayer
}

export const resolveRecentAppEntity = (appId) => {
    const ref = RECENT_APP_ENTITY_REFS[appId]
    if (!ref) return null
    return functionRouteEntities.find(e => e.group === ref.group && e.key === ref.key)
}
